import type { OrganizationJob } from 'state/remote/types';

const getJobHourlyRates = (job: OrganizationJob): string => {
  if (job.assigned_to) {
    if (job.is_vat_exempt) {
      return `€${job.rate_exempt.toFixed(2)} (vrij)`;
    }
    return `€${job.rate.toFixed(2)} (excl) / €${job.rate_incl.toFixed(
      2,
    )} (incl)`;
  }
  return `Max €${job.max_rate?.toFixed(2) || '--'} (excl) / €${
    job.max_rate_incl?.toFixed(2) || '--'
  } (incl) / €${job.max_rate_exempt?.toFixed(2) || '--'} (vrij)`;
};

export default getJobHourlyRates;
